export const INTEREXTRAPOLATE_API_PATHS = {
    FILL_GAPS: "/interextrapolate/fill-gaps",
    REFRESH_EXTRAPOLATION: "/interextrapolate/refresh",
};